<template>
  <v-reports
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  ></v-reports>
</template>
<script>
export default {
  name: "ReportsModifier",
  data: () => ({
    headers: [
      {
        text: "Modifier",
        value: "modifier_name",
        available: true,
        disabled: true,
        width: 200
      },
      {
        text: "Quantity sold",
        value: "quantity_sold",
        available: true,
        align: "right"
      },
      {
        text: "Gross sales",
        value: "gross_sales",
        available: true,
        align: "right"
      },
      {
        text: "Quantity refunded",
        value: "quantity_refunded",
        available: false,
        align: "right"
      },
      { text: "Refunds", value: "refunds", available: false, align: "right" },
      { text: "Net sales", value: "net_sales", available: true, align: "right" }
    ],
    data: [],
    params: {},
    page: 1,
    numPages: 1,
    data_loading: false
  }),
  methods: {
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    async update(params) {
      this.params = params;
      this.data_loading = true;
      var start_date = new Date(params.start_date).getTime();
      var end_date = new Date(params.end_date).getTime();
      
      var modifiers = this.$communicator.then(
        this,
        await this.$communicator("by_modifier", {
          arguments: [start_date, end_date, 10, this.page],
          params: {
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service != "" ? [params.service] : [],
            employees:
              params.employee && params.employee._id != ""
                ? [params.employee._id]
                : []
          }
        })
      );
      if (modifiers) {
        for (let i = 0; i < modifiers.data.length; i++) {
          modifiers.data[i].gross_sales = Math.round(
            modifiers.data[i].gross_sales
          ).toLocaleString();
          modifiers.data[i].refunds = Math.round(
            modifiers.data[i].refunds
          ).toLocaleString();
          modifiers.data[i].net_sales = Math.round(
            modifiers.data[i].net_sales
          ).toLocaleString();
        }
        this.data = modifiers.data;
        this.data_loading = false;
        this.numPages = modifiers.page;
      }
    }
  },
  mounted() {
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  }
};
</script>
